import { render } from "./MessageAlertNewSetup.vue?vue&type=template&id=37787fa7&scoped=true"
import script from "./MessageAlertNewSetup.vue?vue&type=script&lang=js"
export * from "./MessageAlertNewSetup.vue?vue&type=script&lang=js"

import "./MessageAlertNewSetup.vue?vue&type=style&index=0&id=37787fa7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37787fa7"]])

export default __exports__